<template>
  <div>
    <el-table
      :data="dataList"
      :loading="loading"
      style="width: 100%; height: calc(100vh - 357px);"
    >
      <el-table-column prop="jbdw" label="经办单位" align="center"></el-table-column>
      <el-table-column prop="jbr" label="经办人" align="center"></el-table-column>
      <el-table-column prop="jbrq" label="经办日期" align="center"></el-table-column>
      <el-table-column prop="htmc" label="合同名称" align="center"></el-table-column>
      <el-table-column prop="htbh" label="合同编号" align="center"></el-table-column>
      <el-table-column prop="jflb" label="纠纷类别" align="center"></el-table-column>
      <el-table-column prop="sjje" label="涉及金额" align="center"></el-table-column>
      <el-table-column prop="xdfqk" label="相对方情况" align="center"></el-table-column>
      <el-table-column prop="jfjsjjy" label="纠纷简述及建议" align="center"></el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions } from 'vuex'

export default {
  components: {
    CrmButton,
  },
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions({
      getInsideAbnormalReportRecordList: 'compactInside/getInsideAbnormalReportRecordList',
    }),
    // 点击tab发送请求
    queryList() {
      const param = {
        contractId: this.id,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }
      this.getInsideAbnormalReportRecordList(param).then(res => {
        this.dataList = res.results
        this.totalCount = res.totalCount
        this.pageNumber = res.pageNumber
        this.pageSize = res.pageSize
      }).catch(e => {
        console.log(e)
      })
    },
    handleSizeChange(value) {
      this.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.pageNumber = value
      this.queryList()
    },
  },
}
</script>
